import { SortOptions } from '../../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../../ts/models/sort/SortOptionDefinitions';

export const workbookAccelerationSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  'hits': SortOptions.hits,
  'sheet': SortOptions.sheetIndex,
};
